module.exports = __webpack_public_path__ + "static/media/UI_CheckboxFill.a0fdc2f4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/icons/svg/UI_CheckboxFill.svg
// module id = 2326
// module chunks = 0